import { useClient, useDictionary } from "@adamlip/okeoke.client";
import Icon from "assets/icons";
import { MainContext } from "contexts/MainContext";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import needLogin from "utils/NeedLogin-v1";

export default function NavButton({
  path,
  svgName,
  text,
  text2,
  className,
  multiLangText,
  multiLangText2,
  customColor,
}) {
  const navigate = useNavigate();
  const { getValue } = useDictionary();
  const { tokenData, getName } = useClient();

  const { handlePingLogin } = useContext(MainContext);

  const [disabled, setDisabled] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (tokenData?.valid != null) {
      setLoggedIn(tokenData?.valid);
    }
  }, [tokenData]);

  useEffect(() => {
    if (needLogin(path) && !loggedIn) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [loggedIn, path]);

  const handleClickOnNavButton = () => {
    if (disabled) {
      handlePingLogin();
      toast.error("Jelentkezz be!");
      return null;
    }
    navigate(path);
  };

  const style = customColor != null ? { background: customColor } : {};

  return (
    <div
      className={`navButton-root ${disabled ? "disabled" : "primary"} ${
        className != null ? className : ""
      } ${
        (text2 == null || text2 === "") && multiLangText2 == null
          ? "single-line"
          : ""
      }`}
      onClick={handleClickOnNavButton}
    >
      <div className="navButton-inner-container" style={style}>
        {svgName != null && (
          <div className="navButton-icon">
            <div className="w-10 h-10">
              <Icon
                name={svgName}
                className={"stroke-[var(--startNav-text-color)]"}
                secondClassName={"fill-[var(--startNav-text-color)]"}
              />
            </div>
          </div>
        )}
        <div className="texts">
          <div className="navButton-text">
            {text != null && getValue(text)}
            {(text == null || text === "") && getName(multiLangText)}
          </div>
          <div className="navButton-text text2">
            {text2 != null && getValue(text2)}
            {(text2 == null || text2 === "") && getName(multiLangText2)}
          </div>
        </div>
      </div>
    </div>
  );
}
